const API_BASE_URL = '/api';

export const api = {
  // Auth
  async login(email, password) {
    const response = await fetch(`${API_BASE_URL}/auth/login`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ email, password })
    });
    if (!response.ok) throw new Error('Login fehlgeschlagen');
    return response.json();
  },

  async forgotPassword(email) {
    const response = await fetch(`${API_BASE_URL}/auth/forgot-password`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ email })
    });
    if (!response.ok) throw new Error('Passwort-Reset fehlgeschlagen');
    return response.json();
  },

  async changePassword(newPassword) {
    const response = await fetch(`${API_BASE_URL}/auth/change-password`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${localStorage.getItem('token')}`
      },
      body: JSON.stringify({ newPassword })
    });
    if (!response.ok) throw new Error('Passwort konnte nicht geändert werden');
    return response.json();
  },

  // Profile
  async updateProfile(updates) {
    const response = await fetch(`${API_BASE_URL}/profile`, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${localStorage.getItem('token')}`
      },
      body: JSON.stringify(updates)
    });
    if (!response.ok) throw new Error('Fehler beim Aktualisieren des Profils');
    return response.json();
  },

  // Users
  async getUsers() {
    const response = await fetch(`${API_BASE_URL}/users`, {
      headers: { 'Authorization': `Bearer ${localStorage.getItem('token')}` }
    });
    if (!response.ok) throw new Error('Fehler beim Laden der Benutzer');
    return response.json();
  },

  async getUser(userId) {
    const response = await fetch(`${API_BASE_URL}/users/${userId}`, {
      headers: { 'Authorization': `Bearer ${localStorage.getItem('token')}` }
    });
    if (!response.ok) throw new Error('Fehler beim Laden des Benutzers');
    return response.json();
  },

  async createUser(userData) {
    const response = await fetch(`${API_BASE_URL}/users`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${localStorage.getItem('token')}`
      },
      body: JSON.stringify(userData)
    });
    if (!response.ok) throw new Error('Fehler beim Erstellen des Benutzers');
    return response.json();
  },

  async updateUser(userId, updates) {
    const response = await fetch(`${API_BASE_URL}/users/${userId}`, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${localStorage.getItem('token')}`
      },
      body: JSON.stringify(updates)
    });
    if (!response.ok) throw new Error('Fehler beim Aktualisieren des Benutzers');
    return response.json();
  },

  async deleteUser(userId) {
    const response = await fetch(`${API_BASE_URL}/users/${userId}`, {
      method: 'DELETE',
      headers: { 'Authorization': `Bearer ${localStorage.getItem('token')}` }
    });
    
    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.error || 'Fehler beim Deaktivieren des Benutzers');
    }
    
    return response.json();
  },

  // Leads
  async getLeads() {
    const response = await fetch(`${API_BASE_URL}/leads`, {
      headers: { 'Authorization': `Bearer ${localStorage.getItem('token')}` }
    });
    if (!response.ok) throw new Error('Fehler beim Laden der Leads');
    return response.json();
  },

  async getLead(id) {
    const response = await fetch(`${API_BASE_URL}/leads/${id}`, {
      headers: { 'Authorization': `Bearer ${localStorage.getItem('token')}` }
    });
    if (!response.ok) throw new Error('Fehler beim Laden des Leads');
    return response.json();
  },

  async createLead(leadData) {
    const response = await fetch(`${API_BASE_URL}/leads`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${localStorage.getItem('token')}`
      },
      body: JSON.stringify(leadData)
    });
    if (!response.ok) throw new Error('Fehler beim Erstellen des Leads');
    return response.json();
  },

  async updateLead(id, updates) {
    const response = await fetch(`${API_BASE_URL}/leads/${id}`, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${localStorage.getItem('token')}`
      },
      body: JSON.stringify(updates)
    });
    if (!response.ok) throw new Error('Fehler beim Aktualisieren des Leads');
    return response.json();
  },

  async updateLeadStatus(leadId, status) {
    const response = await fetch(`${API_BASE_URL}/leads/${leadId}/status`, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${localStorage.getItem('token')}`
      },
      body: JSON.stringify({ status })
    });
    if (!response.ok) throw new Error('Fehler beim Aktualisieren des Lead-Status');
    return response.json();
  }
};

export const createPublicLead = async (userId, leadData) => {
  try {
    const response = await fetch(`${API_BASE_URL}/leads/public/${userId}`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(leadData)
    });
    
    if (!response.ok) {
      const errorText = await response.text();
      throw new Error(`Netzwerk-Antwort war nicht ok: ${errorText}`);
    }
    
    return await response.json();
  } catch (error) {
    console.error('Vollständiger Fehler:', error);
    throw new Error('Fehler beim Erstellen des Leads: ' + error.message);
  }
}; 